/** Builder section types of the `common` templates. No imports: `entities/LandingPage` reads it. */
export const commonSectionTypes = ["funnelLandingEffects"] as const;
